/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Metrics.Performance_
///   This is an auto-generated enumeration of the SWFC_Learning.Metrics.Performance domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum Performance_ {
   /// <summary>
   ///   Unknown (unk)
   /// </summary>
   Unknown = 0,
   /// <summary>
   ///   Passed (pass)
   /// </summary>
   Passed = 1,
   /// <summary>
   ///   Failed (fail)
   /// </summary>
   Failed = 2
}

export const Performances: Performance[] = [
   {
      code: Performance_.Unknown,
      literal: 'Unknown',
      description: 'Unknown',
      shortDescription: 'unk',
      listPriority: 0,

      typeName: "Performance"
   },
   {
      code: Performance_.Passed,
      literal: 'Passed',
      description: 'Passed',
      shortDescription: 'pass',
      listPriority: 0,

      typeName: "Performance"
   },
   {
      code: Performance_.Failed,
      literal: 'Failed',
      description: 'Failed',
      shortDescription: 'fail',
      listPriority: 0,

      typeName: "Performance"
   }
]

export class Performance implements IDomainModel {
   code: Performance_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: Performance_): Performance {
      return Performances.find(d => d.code === code)
   }
}
